import ShapeConfigurationFactory from "@/Models/ShapeConfigurations/ShapeConfigurationFactory";

export default class ShapeValidator {
	isShapeComplete ( shape: string, measurements, uploadAsModel = null ): boolean {
		if ( shape === 'dxf') {
			return uploadAsModel !== null;
		}

		if (!measurements.dimensions[shape]) {
			return false;
		}

		const hasRequiredDimensions = this.requiredDimensions( shape ).reduce( ( canPreview, requiredDimension ) => {
			const dimensionValue = measurements.dimensions[ shape ][ requiredDimension ];

			return canPreview && ! isNaN( dimensionValue );
		}, shape !== '' );

		return this.requiredModifiers( shape ).reduce( ( canPreview, requiredPrimitive ) => {
			const dimensionValue = measurements.modifiers[ requiredPrimitive ];

			return canPreview && !! dimensionValue;
		}, hasRequiredDimensions );
	}

	requiredDimensions ( shape: string ): string[] {
		return ( new ShapeConfigurationFactory() ).get_configuration( shape ).get_dimension_keys();
	}

	requiredModifiers( shape: string ): string[] {
		return new ShapeConfigurationFactory().get_configuration(shape).get_modifier_keys();
	}
}
